export const REQUIREMENTS = {
  TOPFAN_HDN: 'TopFan Creator Requirements',
  MAIN_REQUIREMENTS: [
    'You must be 18 years of age or older.',
    'Have at least 10,000 followers across other social platforms.',
    'Not create sexually focused, hateful or harmful content.',
    'Pass a 3rd Party Identity Verification.'
  ],
  MANUAL_REVIEW:
    "All creator applications are reviewed by TopFan's staff to ensure the safety and quality of the community, and approvals are at the sole discretion of TopFan.",
  AGENCY_PROCESS: 'If you are represented by a Talent Agency, email us at',
  AGENCY_MAIL: ' agency@topfans.com ',
  AGENCY_DESC: 'to expedite this process.',
  AGREEMENT: {
    YOU_AGREE: "I agree to TopFan's",
    TERMS_OF_SERVICE: 'Terms of Service',
    CONTENT_GUIDELINES: ' & Acceptable Content Policy.'
  },
  APPLY_BTN: 'Apply To Become a Creator',
  CANCEL: 'CANCEL',
  TERMS: 'terms-conditions',
  PRIVACY: 'privacy-policy',
  SUBJECT: 'Agency Represented Creator Application'
};
